<script setup lang="ts">
const { headerMenu } = await useMenu();
</script>
<template>
  <HeaderLinkBottom :list="headerMenu" />
</template>
